// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3JB_O","rootCenter":"LoadMoreObserver_rootCenter__3_DmB","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__dtZbq"};